import React from 'react';

export default function LargePreviewModal({ imageUrl, onClose }) {
    return (
        <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-[400] p-4 cursor-zoom-out" onClick={onClose}>
            <div className="relative w-full h-full max-w-7xl flex items-center justify-center animate-fade-in" onClick={(e) => e.stopPropagation()}>
                <img 
                    src={imageUrl} 
                    alt="Expanded preview" 
                    className="max-w-full max-h-full object-contain rounded-lg shadow-2xl cursor-default" 
                />
                <button
                    onClick={onClose}
                    className="fixed top-4 right-4 bg-white/10 hover:bg-white/20 backdrop-blur-md text-white rounded-full h-10 w-10 flex items-center justify-center text-xl font-bold shadow-lg transition z-50 border border-white/20 cursor-pointer"
                >
                    &times;
                </button>
            </div>
        </div>
    );
}